import { Component } from '@angular/core';
import { EmptyComponent } from "../../../shared/components/empty/empty.component";
import { OptionSwitchComponent, OptionSwitchItem } from "../../../shared/components/option-switch/option-switch.component";
import { RevenueChartBarsService } from '../../../shared/services/revenue-bar-chart.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'staff-overview',
    imports: [EmptyComponent, OptionSwitchComponent],
    templateUrl: './overview.component.html',
    styleUrl: './overview.component.scss'
})
export class StaffOverviewComponent {
  readonly periodOptions: OptionSwitchItem[];
  appointments = [1];
  assetUrl = environment.assetBaseUrl


  constructor(private chartService: RevenueChartBarsService) {
    this.periodOptions = this.chartService.periodOptions;
  }

  onPeriodChange(x: any) {

  }
}
